import instance from "../../api";
import { IDynamicTableParams } from "../../components/DynamicTable";

export const getEvents = (data: IDynamicTableParams) => {
    return instance().post("/event/listRegister", data).then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/event/availableColumns").then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/event/availableGroupColumns").then(response => response.data);
}